/* eslint-disable no-unused-vars */
enum AuthRequestType {
  AUTHENTICATE = 'authorization_code',
  REFRESH = 'refresh_token',
}

export default AuthRequestType;
